<template>
  <div>
      <section class="xlrclh">
          <img class="top-img" src="./../assets/imgs/136/base.png" alt="" />
          <div class="technological-process">
              <div class="rhtj mar-t2">
                  <img
                      class="top"
                      src="./../assets/imgs/xllh/rcgyysq_zcjj.png"
                      alt=""
                  />
                  <div class="content">
                    为深入贯彻习近平总书记关于推动乡村人才振兴的重要指示精神，全面落实中央、省、市有关决策部署，着力壮大农业职业经理人队伍，强化乡村振兴人才支撑，制定本措施。
                  </div>
              </div>
              <div class="zccl">
                  <img
                      class="top"
                      src="./../assets/imgs/136/title1.png"
                      alt=""
                  />
                  <div class="content">
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （一）拓宽农业职业经理人培育选拔范围
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            把正在从事或有意愿从事农业生产经营和社会化服务的人员全部纳入培育选拔范围。以镇（街道）为单位组织开展需求摸底，建立培育对象名录库，分年度制定培育计划，广泛选拔各类人才，发展壮大一支有文化、懂技术、善经营、会管理的农业职业经理人队伍。到2025年，全市培育打造一支以5万名农业职业经理人为引领、拥有40万人以上规模的高素质农民人才方阵。〔责任单位：市农业农村局，市发改委、市科技局、市财政局、市人社局、各区（市）县（逗号前为牵头单位，下同）〕
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （二）实行农业职业经理人分层分类培训
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            由市级统筹，市和区（市）县分层组织培训，市级重点抓好高级农业职业经理人知识更新培训，区（市）县重点抓好初始培训和初级、中级农业职业经理人知识更新培训。分产业分行业制定培训规范，整合在蓉涉农培训资源，采取理论与实践、集中与分段相结合的方式，分类开展培训。到2025年，提升建设优质培训（实训）基地100个以上，每年培训10万人次以上。〔责任单位：市农业农村局，市教育局、市科技局、市财政局、市人社局、各区（市）县〕
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （三）完善农业职业经理人评价体系
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            优化调整农业职业经理人评价方式，在原有等级评价基础上，探索建立中高级农业职业经理人直评制度。对大中专毕业生、取得中级以上技术职称人员，或在我市乡村振兴中取得一定实绩的下乡创业人员、返乡农民工、退役军人等，在符合管理要求和相关规定的前提下，可申报直评为中级农业职业经理人。对获得省级以上相关技能竞赛奖励的或高层次人才，可直评为高级农业职业经理人。〔责任单位：市农业农村局，市发改委、市科技局、市财政局、市人社局、各区（市）县〕
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （四）实施农业职业经理人“头雁”计划
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            聚焦“4+6”都市现代农业产业体系，每年选取一批综合素质高、经营业绩好、带动能力强的农业职业经理人作为乡村产业振兴“头雁”。市和区（市）县每年组织实施一批优势特色产业“头雁”项目，发挥“头雁”在技术推广、品牌营销、联农助农等方面的示范带动作用。支持农业职业经理人申报乡村产业振兴带头人培育“头雁”项目。到2025年全市培育“头雁”1000人以上。〔责任单位：市农业农村局，市科技局、各区（市）县〕
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （五）强化农业职业经理人产业引领
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            支持农业职业经理人领办创办农业企业、农民合作社、家庭农场等新型农业经营主体和服务主体。发挥农业职业经理人在保障粮食安全和重要农产品保供中的积极作用，带头严格落实遏制耕地“非农化”、防止“非粮化”要求，每年指导农业职业经理人建设一批粮食生产或粮经复合产业基地。鼓励农业职业经理人通过应聘集体经济专员等方式，助推新型农村集体经济发展壮大。鼓励引导农业职业经理人拓展农业多种功能，发展乡村新产业新业态，每年推出农业职业经理人领办创办的一二三产业融合发展新场景200个。〔责任单位：市农业农村局，市规划和自然资源局、市文广旅局、各区（市）县〕
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （六）开展农业职业经理人科技帮扶行动
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            组建农业科技专家服务团，采取导师制对农业职业经理人进行结对指导。建设农业科技示范基地，围绕省市推介发布的年度农业主推技术，支持有条件的农业职业经理人开展试验示范。依托全国农业科技成果转化大会，举办农业职业经理人专场活动，引导农业职业经理人参与转化应用重大农业科技成果。对农业职业经理人领办、新办、经营的农民合作社或企业进行农业科技成果研发、推广、应用和转化的，符合相关条件的，给予立项支持。〔责任单位：市农业农村局，市科技局、市博览局、各区（市）县〕
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （七）强化农业职业经理人金融服务供给
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            鼓励各类金融机构面向农业职业经理人开发新型金融产品，扩大对农业职业经理人的创业、强业贷款规模。根据农业职业经理人条件，通过“农贷通”平台给予最高100万元贷款授信；对在我市从事粮油种植、生猪养殖、现代种业通过“农贷通”平台融资贷款的，按当期银行贷款市场报价利率给予全额贴息（贷款利率低于当期银行贷款市场报价利率的，按实际利率贴息），每人每年度贴息总额最高50万元。对在我市从事规模种养生产参加政策性农业保险的农业职业经理人，给予自缴保费部分20%的补助，补助资金在市级政策性农业保险补助专项资金中安排。〔责任单位：市农业农村局、市金融监管局，市财政局、各区（市）县〕
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （八）鼓励农业职业经理人参加养老保险
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            对符合条件的农业职业经理人以个体身份参加企业职工基本养老保险的，以上一年度四川省全口径城镇单位就业人员月平均工资的60%为缴费基数，缴费费率为20%，其中农业职业经理人个人缴费8%，财政补贴12%。缴费地在四川天府新区、成都东部新区、龙泉驿区、青白江区、新都区、温江区、双流区、郫都区的，其财政补贴资金由区级财政承担；缴费地在新津区、简阳市、都江堰市、彭州市、邛崃市、崇州市、金堂县、大邑县、蒲江县的，其财政补贴资金由市和区（市）县财政分别按60%、40%比例承担。养老保险补贴实行“先缴后补”方式给予补贴，每个农业职业经理人享受补贴累计不超过60个月。〔责任单位：市农业农村局，市财政局、市人社局、各区（市）县〕
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （九）健全农业职业经理人服务体系
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            健全联动协调机制，完善全市农业职业经理人人才资源信息库。组织农业职业经理人参加涉农展会和推介活动。以镇（街道）农业服务中心为依托，建立农业职业经理人服务站点，开展政策宣传、信息咨询、金融保险及相关手续办理等服务。指导农业职业经理人协会规范建设，定期举办农业沙龙、资源对接、经验交流等活动。〔责任单位：市农业农村局，市发改委、市科技局、市民政局、市财政局、市人社局、各区（市）县〕
                          </div>
                      </div>
                      <div class="circle-box">
                        <div class="circle"></div>
                        <div class="circle-txt">
                          （十）深化农业职业经理人考核激励
                        </div>
                      </div>
                      <div class="des" style="margin-top: 0.26rem;">
                          <div >
                            优化进退有序的考核方式，每年定期对农业职业经理人的职业素养、经营规模、工作业绩和诚信等情况进行动态考核，出具维持、提升、降低或取消等级的考核结果。每年开展“十佳”“优秀”农业职业经理人评选，加大宣传力度，选树好典型，吸引更多人才加入农业职业经理人队伍，营造全社会关注农业、关心农村、关爱农民的良好氛围。〔责任单位：市农业农村局，市发改委、市科技局、市财政局、市人社局、各区（市）县〕
                          </div>
                      </div>
                      <div class="tips">本措施自2022年5月6日起施行，有效期2年。</div>
                  </div>
              </div>
          </div>
      </section>
      <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
      return {};
  },

  components: {
      call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  padding-bottom: 0.48rem;

  .top-img {
      width: 6.72rem;
      height: 2.14rem;
      margin-top: 0.63rem;
  }

  .technological-process {
      transform: translateY(0rem);

      .rhtj {
          position: relative;

          .top {
              width: 6.86rem;
              height: 1.12rem;
          }

          .content {
              width: 6.85rem;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              background: #ffffff;
              font-size: 0.26rem;
              color: #4e4e4e;
              text-align: left;
              position: relative;
              font-weight: 500;
              line-height: 0.44rem;
          }
      }

      .zccl {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.85rem;
              background: #e8eeff;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              padding-top: 0.28rem;
              font-size: 0.26rem;
              font-weight: 500;
              text-align: left;
              color: #4e4e4e;
              line-height: 0.44rem;

              .circle-box {
                font-size: 0.34rem;
                color: #333;
                font-weight: bold;
                padding-top: 0.3rem;
                text-align: left;
                position: relative;
                .circle {
                  width: 0.28rem;
                  height: 0.28rem;
                  border: 0.06rem solid #FF6D60;
                  border-radius: 50%;
                  flex-shrink: 0;
                  box-sizing: border-box;
                  position: absolute;
                  left: 0;
                  top: 0.35rem;
                  display: inline-block;
                }
                .circle-txt {
                  text-indent: 0.6em;
                }
              }

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.35rem 0.23rem 0.3rem;
                  margin-top: 0.8rem;
                  position: relative;
                  text-align: left;

                  .title {
                      position: absolute;
                      top: -0.5rem;
                      left: 50%;
                      transform: translateX(-50%);
                      width: 4.86rem;
                      height: 0.67rem;
                      line-height: 0.67rem;
                      display: flex;
                      justify-content: center;
                      align-content: center;
                      font-size: 0.32rem;
                      font-weight: bold;
                      color: #ffffff;
                      border-radius: 1rem;
                      background-color: #739bfe;
                  }
              }
              .tips {
                margin-top: 0.2rem;
                color: #4E4E4E;
                font-size: 0.26rem;
              }
          }
      }

      .gmlc {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.86rem;
              background: #e8eeff;
              margin: -0.55rem auto;
              padding: 0 0.33rem 0.35rem 0.36rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;

              .circle-box {
                font-size: 0.34rem;
                color: #333;
                font-weight: bold;
                padding-top: 0.5rem;
                text-align: left;
                position: relative;
                .circle {
                  width: 0.28rem;
                  height: 0.28rem;
                  border: 0.06rem solid #FF6D60;
                  border-radius: 50%;
                  flex-shrink: 0;
                  box-sizing: border-box;
                  position: absolute;
                  left: 0;
                  top: 0.62rem;
                  display: inline-block;
                }
                .circle-txt {
                  text-indent: 1.1em;
                }
              }

              .title {
                  font-size: 0.36rem;
                  font-weight: bold;
                  color: #333333;
                  text-align: left;
                  line-height: 0.5rem;
              }

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.3rem 0.23rem;
                  font-size: 0.26rem;
                  font-weight: 500;
                  color: #4e4e4e;
                  line-height: 0.44rem;

                  .line-item {
                      font-size: 0.26rem;
                      position: relative;
                      z-index: 3;

                      .line {
                          position: absolute;
                          width: 0.02rem;
                          height: 130%;
                          border-left: 0.02rem dashed #739bfe;
                          left: 0.2rem;
                          z-index: 0;
                          //   background-color: #739bfe;
                      }

                      .line-title {
                          font-size: 0.3rem;
                          font-weight: bold;
                          color: #3d5aa3;
                      }

                      .line-top {
                          display: flex;
                          width: 4.4rem;
                          height: 0.55rem;
                          background-image: url(../assets/imgs/25/label.png);
                          background-size: 100% 100%;
                          z-index: 99;
                          display: flex;
                          align-items: center;
                          box-sizing: border-box;
                          padding-left: 0.1rem;

                          .line-num {
                              width: 0.44rem;
                              height: 0.44rem;
                              background: #fff;
                              color: #3d5aa3;
                              display: inline-flex;
                              border-radius: 50%;
                              justify-content: center;
                              align-items: center;
                              margin-right: 0.18rem;
                              position: relative;
                              z-index: 3;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              font-size: 0.28rem;
                              font-weight: bold;
                          }
                      }

                      .line-content {
                          //   border-left: 0.02rem dashed #739bfe;
                          padding-bottom: 0.32rem;
                          margin-left: 0.2rem;
                          padding-left: 0.32rem;
                          padding-top: 0.15rem;
                          word-break: break-all;
                          line-height: 0.44rem;
                      }
                  }
              }
          }
      }

      .codes {
          margin: 0 auto;
          margin-top: 0.25rem;
          width: 6.85rem;
          background: #fff;
          padding: 0.3rem;
          box-sizing: border-box;
          border-radius: 0.26rem;
          padding-top: 0.28rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .info {
            width: 100%;
            height: 100%;
          }
      }
  }
}
</style>
